export default "__VITE_ASSET__256d2379__"